
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/machinery",
      function () {
        return require("private-next-pages/machinery/index.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/machinery"])
      });
    }
  